import Skeleton from '@material-ui/core/Skeleton';
import styled from 'styled-components';
import { Grid } from '@material-ui/core';

const countSkeleton = [1, 2, 3];

const IdeasSkeleton = () => {
  const TextSkeleton = () => {
    return (
      <Skeleton
        variant="text"
        width={304}
        height={48}
        style={{ marginTop: '-60px' }}
      />
    );
  };

  const ChipSkeleton = () => {
    return (
      <Skeleton
        variant="text"
        width={184}
        height={48}
        style={{ marginTop: '-10px' }}
      />
    );
  };

  const CardSkeleton = () => {
    return (
      <Skeleton
        style={{ borderRadius: 15 }}
        variant="text"
        width={304}
        height={327}
      />
    );
  };

  return (
    <>
      {countSkeleton.map(item => {
        return (
          <ParentSkeleton key={item} container wrap="nowrap">
            <div>
              <CardSkeleton />
              <TextSkeleton />
              <ChipSkeleton />
            </div>
            <div>
              <CardSkeleton />
              <TextSkeleton />
              <ChipSkeleton />
            </div>
            <div>
              <CardSkeleton />
              <TextSkeleton />
              <ChipSkeleton />
            </div>
            <div>
              <CardSkeleton />
              <TextSkeleton />
              <ChipSkeleton />
            </div>
            <div>
              <CardSkeleton />
              <TextSkeleton />
              <ChipSkeleton />
            </div>
          </ParentSkeleton>
        );
      })}
    </>
  );
};

const ParentSkeleton = styled(Grid)`
  display: flex;
  gap: 20px;
`;

export default IdeasSkeleton;
